import React from 'react';

class Toggle extends React.Component {
    constructor(props) {
        super(props);
        this.handleToggleClick = this.handleToggleClick.bind(this);
    }

    handleToggleClick() {
        this.props.onToggle(!this.props.isToggled);
    }

    render() {
        return (
            <div className={`toggle ${this.props.isToggled ? 'isToggled' : 'isNotToggled'}`}
                 onClick={() => this.handleToggleClick()}>
                <div className="toggle-point"></div>
            </div>
        )
    }
}

export default Toggle;
